export const chartGridPositions = [0, 25, 50, 75, 100];

export enum ChartDatasetIndex {
  DATA_INDEX = 0,
  RESPONDENT_INDEX = 1,
}

export enum ChartScoreRangeIndex {
  ATTENTION_INDEX = 0,
  THRIVING_INDEX = 2,
}
